import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=5026e018&scoped=true&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&id=5026e018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026e018",
  null
  
)

export default component.exports